import {ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogRef} from '@angular/material/dialog';
import {MatFormField} from '@angular/material/form-field';
import {MatAutocomplete, MatAutocompleteTrigger, MatOption} from '@angular/material/autocomplete';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {CriterionService, IndicatorService, LandmarkService, ReferenceService} from '../../../apiModule1';
import {AsyncPipe, JsonPipe, NgClass, NgStyle} from '@angular/common';
import {MatLabel, MatSelect} from '@angular/material/select';
import {MatInput} from '@angular/material/input';
import {map} from 'rxjs/operators';
import {MultiSelectComponent} from '../../../../shared/components/multi-select/multi-select.component';
import {MultiSelect2Component} from '../../../../shared/components/multi-select2/multi-select2.component';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {OnInputChange} from '../../OnInputChange';

@Component({
  selector: 'pas-filter-dialog-lanmarks',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton,
    MatFormField,
    MatAutocomplete,
    MatOption,
    ReactiveFormsModule,
    MatAutocompleteTrigger,
    MatFormField,
    MatLabel,
    AsyncPipe,
    MatSelect,
    MatInput,
    MatButton,
    NgClass,
    NgStyle,
    MatDialogClose,
    MultiSelectComponent,
    MultiSelect2Component,
    JsonPipe
  ],
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss','../../index-entity/filter-dialog/filter-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterDialogComponent implements OnInit {
  cdr = inject(ChangeDetectorRef);
  dialogRef = inject(MatDialogRef<FilterDialogComponent>);
  referenceService = inject(ReferenceService);
  data: Record<string, any> = inject(MAT_DIALOG_DATA)
  indicatorService = inject(IndicatorService);
  criterionService = inject(CriterionService);
  landmarkService = inject(LandmarkService);

  indexes: IndexEntry[] = []

  archiveStatuses: Status[] = []


  periods: CriterionPeriod[] = []
  criterions: Criterion[] = []
  landmarks: Landmark[] = []
  indicators: Indicator[] = []

  form = new FormGroup({
    archive: new FormControl(this.data && this.data['statusIds'] || []),
    criterion: new FormControl(this.data && this.data['criterionIds'] || []),
    landmark: new FormControl(this.data && this.data['landmarkIds'] || []),
    period: new FormControl(this.data && this.data['periodIds'] || []),
    indicator: new FormControl(this.data && this.data['indicatorIds'] || []),
  })

  dataCriterion: OnInputChange<Criterion>
  dataLandmark: OnInputChange<Landmark>
  dataIndicator: OnInputChange<Indicator>

  onNoClick(): void {
    this.dialogRef.close();
  }

  constructor(
    private destroyRef: DestroyRef,
  ) {
    this.dataCriterion = new OnInputChange(this.criterionService,'apiCriterionFilterlistGet', 'landmark')
    this.dataIndicator = new OnInputChange(this.indicatorService, 'apiIndicatorFilterlistGet', 'landmark')
    this.dataLandmark = new OnInputChange(this.landmarkService,'apiLandmarkFilterlistGet', 'landmark')
  }


  ngOnInit(): void {
    console.log('filter-dialog data', this.data);

    this.referenceService.apiReferencePeriodsGet().pipe(map(v => v.values))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((v: CriterionPeriod[]) => {
      this.periods = v;
    })

    this.referenceService.apiReferenceStatusesGet().pipe(map(v => v.values))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((v: Status[]) => {
      this.archiveStatuses = v;
    })

    this.referenceService.apiReferencePeriodsGet().pipe(map(v => v.values))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((v: CriterionPeriod[]) => {
      this.periods = v;
    })



    this.dataCriterion.on()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(v => {
      this.criterions = v;
      this.cdr.markForCheck();
    })
    this.dataIndicator.on()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(v => {
      this.indicators = v;
      this.cdr.markForCheck();
    })
    this.dataLandmark.on()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(v => {
      this.landmarks = v;
      this.cdr.markForCheck();
    })

  }


  onReset(): void {
    this.form.reset();
  }

  onApply() {

    const res = {
      statusIds: this.form.get('archive')!.value,
      criterionIds: this.form.get('criterion')!.value,
      landmarkIds: this.form.get('landmark')!.value,
      periodIds: this.form.get('period')!.value,
      indicatorIds: this.form.get('indicator')!.value
    }

    this.dialogRef.close(res);
  }

}



